export function invitationEmail(customer) {
    return customer?.billing_address?.emails?.find(email => typeof email === 'string' && email.includes('@')) || customer?.contact_email || '';
}
export function invitationQueries(customer) {
    return [...new Set([customer?.siret?.replace(/\s/g, ''), customer?.siren?.replace(/\s/g, ''), invitationEmail(customer), customer?.name].map(value => (value || '').trim()).filter(Boolean))];
}
export function mergeInvitationMatches(lists) {
    const matches = new Map();
    lists.flat().forEach(item => { if (item?.id != null && !matches.has(item.id)) matches.set(item.id, item); });
    return [...matches.values()];
}
